import { render, staticRenderFns } from "./DoctorDesc.vue?vue&type=template&id=6f5e4fb7&scoped=true&"
import script from "./DoctorDesc.vue?vue&type=script&lang=ts&"
export * from "./DoctorDesc.vue?vue&type=script&lang=ts&"
import style0 from "./DoctorDesc.vue?vue&type=style&index=0&id=6f5e4fb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e4fb7",
  null
  
)

export default component.exports